/**
 *
 * Full Width Block
 *
 * Small function that adjusts parent height to match absolutely positioned child
 */

const $ = require('jquery');

var FullWidthBlock = function (el) {

    //setup some variables
    this.$el = $(el);
    this.$child = this.$el.find('.itbl-c-full_width_block__content');

    this.init();

};

FullWidthBlock.prototype.init = function () {

    // Moving the element to the left:0 of the viewport, without using position:absolute.
    let left = this.$child.position();
    if(left) {
        this.$child.css("margin-left", "-"+left.left+"px");
    }
};

$(document).ready( () => {
    new FullWidthBlock(".js-full-width-block");
} );
